// Lowest selectable year — matches the API's lower bound (@Min(2000) in base_rate_files.dto.ts).
export const MIN_YEAR_OPTION = 2000;

export const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years: { label: string; value: number }[] = [];
  // Next year down to MIN_YEAR_OPTION, newest first
  for (let i = currentYear + 1; i >= MIN_YEAR_OPTION; i -= 1) {
    years.push({ label: String(i), value: i });
  }
  return years;
};
